import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente } from '../usuario/usuario-perfil';


/** Acessos permitidos ao cadastro de regiões */
export const acessosRegiao: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilAtendente];

@Injectable()
export class CanActivateRegiao implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosRegiao);
    }
}
